import React from 'react'
import ReactDOM from 'react-dom'
import AnalyticsRouter from './AnalyticsRouter'
import 'assets/scss/material-kit-react.css?v=1.2.0'

ReactDOM.render(
    <AnalyticsRouter/>,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js